import { render, staticRenderFns } from "./ResponseQuestion.vue?vue&type=template&id=31016d55&scoped=true"
import script from "./ResponseQuestion.vue?vue&type=script&lang=js"
export * from "./ResponseQuestion.vue?vue&type=script&lang=js"
import style0 from "./ResponseQuestion.vue?vue&type=style&index=0&id=31016d55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31016d55",
  null
  
)

export default component.exports